import { getInfoAttributesByInfosData } from "../getInfoAttributesByInfosData";
import { calcularConsumoKwh } from "./CalcularConsumoKWH";
import { calcularValorDescontoAnual } from "./CalcularValorDescontoAnual";

/**
 * Obtém um Object configurado com base na informação de consumoDinheiro:
 * - caso seja possível contratar ML, o json será: { elegivel: true, valorDesconto: XX }
 * - caso não seja possível contratar ML, o json será: { elegivel: false }
 * Para ser elegível ao ML - Mercado Livre, é necessário ser PJ, estar habilidado contratação ML e ter consumo mínimo suficiente
 * @param {'pf'|'pj'} tipoConta Valor em R$ do consumo médio de energia  
 * @param {number} consumoDinheiro Valor em R$ do consumo médio de energia  
 * @param {object} infos -> tabela de configurações do sistema
 * @returns {object} -> { elegivel: true|false, valorDesconto: number }
 */
export function ConfigureLeadMercadoLivre({tipoConta, consumoDinheiro, infos}) {
  // garantindo acesso correto para "infos"
  const info = getInfoAttributesByInfosData({ infos });

  return getDataDescontoElegivelMercadoLivre({ tipoConta, consumoDinheiro, info })
}

/**
 * Valida Elegibilidade de contratação para Mercado Livre calculando valor do desconto, caso elegível
 * @param {pf|pj} tipoConta 
 * @param {number} consumoDinheiro 
 * @param {Object} info -> Dados da Tabela de Infos: {ml_enabled, ml_min_value, ml_min_value, ml_valor_kwh, ml_desconto}
 * @returns 
 */
export function getDataDescontoElegivelMercadoLivre({
  tipoConta, consumoDinheiro, info
}) {
  // somente PJ pode contratar ML
  if(!info || tipoConta != 'pj') {
    return {
      elegivel: false,
    };
  }
  
  // precisa estar habilitado contratação via ML
  if(!info.ml_enabled) {
    return {
      elegivel: false,
    };
  }

  // precisa ter os campos calculáveis configurados corretamente
  if(!info.ml_min_value || !info.ml_desconto || info.ml_desconto <= 0) {
    return {
      elegivel: false,
    };
  }

  // calculando valor do desconto
  // const consumoKwh = calcularConsumoKwh({ consumoDinheiro, valorKwh: info?.ml_valor_kwh });// VALOR CONFIGURADO NO ML É EM R$
  if(consumoDinheiro < info.ml_min_value) {
    return {
      elegivel: false,
    };
  }

  const valorDesconto = calcularValorDescontoAnual({ consumoDinheiro, porcentagem: info.ml_desconto })

  return {
    elegivel: true,
    valorDesconto
  };
}